import PropTypes from 'prop-types';
import Link from '@/Fi16100/Components/Link';
import './NavLink.css';

function NavLink(props) {
	const className = (props.className ?? '') + ' nav-link text-uppercase';

	return (
		<>
			{!props.external &&
				<Link href={props.href} className={className} onClick={props.onClick} aria-current={props.active ? false : 'page'}>
                    <span className={(props.active ? 'text-decoration-underline' : '')}>
                        {props.children}
                    </span>
				</Link>
			}

			{props.external &&
				<a href={props.href} className={className} onClick={props.onClick}>
					{props.children}
				</a>
			}
		</>
	);
}

NavLink.propTypes = {
	href: PropTypes.string,
	className: PropTypes.string,
	active: PropTypes.bool,
	children: PropTypes.node,
	onClick: PropTypes.func,
	external: PropTypes.bool
};

export default NavLink;
